// Harshada Bhavsar (21/07/2025)
// Employee API Services

import axios from "../axios";
import Cookies from "js-cookie";

export const createEmployee = async (formData) => {
  const token = Cookies.get("employeeToken");

  if (!token) {
    throw new Error("Login token missing.");
  }

  const payload = {
    token,
    ...formData,
  };

  return axios.post("/api/Admin/Employee/CreateEmployee", payload);
};
